var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9943 3.27985C8.32817 1.332 5.54979 0.808035 3.46225 2.59168C1.3747 4.37532 1.08081 7.35748 2.72017 9.467C3.95841 11.0604 7.47608 14.2591 9.12334 15.7291C9.42616 15.9993 9.57756 16.1344 9.75486 16.1876C9.90878 16.2338 10.0798 16.2338 10.2337 16.1876C10.411 16.1344 10.5624 15.9993 10.8652 15.7291C12.5125 14.2591 16.0302 11.0604 17.2684 9.467C18.9078 7.35748 18.6498 4.35656 16.5263 2.59168C14.4029 0.826798 11.6604 1.332 9.9943 3.27985Z",
    fill: "#FFF0BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.16667L9.16667 9.83333L12.9167 6.08333M9.99429 3.27985C8.32817 1.332 5.54979 0.808035 3.46225 2.59168C1.3747 4.37532 1.08081 7.35748 2.72017 9.467C3.95841 11.0604 7.47608 14.2591 9.12334 15.7291C9.42616 15.9993 9.57756 16.1344 9.75486 16.1876C9.90878 16.2338 10.0798 16.2338 10.2337 16.1876C10.411 16.1344 10.5624 15.9993 10.8652 15.7291C12.5125 14.2591 16.0302 11.0604 17.2684 9.467C18.9078 7.35748 18.6498 4.35656 16.5263 2.59168C14.4029 0.826798 11.6604 1.332 9.99429 3.27985Z",
    stroke: "#0D3355",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/check-in.7ebc72bf.svg";
export { ForwardRef as ReactComponent };